import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getDataAccessor } from './accessors';
import './styles.less';
import LearningCardItem from './LearningCardItem';
import LearningListItem from './LearningListItem';
import classNames from 'classnames';
import LearningSearchResult from './LearningSearchResult';

const LearningItem = ( { displayType, learningObject, learningType, className, isLoading } ) => {

    const accessorFn = getDataAccessor( learningType ?? learningObject.type );
    const accessor = useMemo( () => {
        if ( !isLoading ) {

            /* IDENTIFY THE ITEM TYPE IF learningType IS UNDEF */

            return accessorFn( learningObject );
        } else {
            return null;
        }
    }, [ isLoading, learningObject ] );

    const cn = classNames( className, 'learning-item' );

    return ( {
        'card': <LearningCardItem dataAccessor={ accessor } className={ cn } isLoading={ isLoading } />,
        'list': <LearningListItem dataAccessor={ accessor } className={ cn } isLoading={ isLoading } />,
        'search': <LearningSearchResult dataAccessor={ accessor } className={ cn } isLoading={ isLoading } />
    }[ displayType ] );
};


LearningItem.propTypes = {
    displayType: PropTypes.oneOf( [ 'card', 'list', 'search' ] ).isRequired,
    learningObject: PropTypes.object.isRequired,
    learningType: PropTypes.oneOf( [ 'course', 'curriculum', 'resource' ] ),
    className: PropTypes.string,
    isLoading: PropTypes.bool,
};

LearningItem.defaultProps = {
    isLoading: false,
    learningType: null
};

export default LearningItem;